import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import { resolveBranding } from "./config/branding";
import "./styles/globals.css";

const branding = resolveBranding();
if (branding.favicon) {
  let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href = branding.favicon;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
